module.exports = __webpack_public_path__ + "static/miss-monique_4-8516c844a771406b3abc91f71ba515bc.jpg";